/* eslint-disable consistent-return */
/* eslint-disable camelcase */

import { updateSaasPaymentSetups } from '@lib/axios/pg'
import { useMutation, useQueryClient } from 'react-query'
import useSuccess from '@hooks/useSuccess'
import useCloseDialog from '@hooks/useCloseDialog'

const useUpdate = () => {
  const showSuccess = useSuccess('Sukses', 'Sukses Mengubah PG')
  const closeDialog = useCloseDialog()
  const queryClient = useQueryClient()
  const mutation = useMutation(
    (data) => updateSaasPaymentSetups(data.id, data.secret_api_key, data.verification_token),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('saas-pg')
      },
    }
  )

  return (data) => mutation.mutate(data, {
    onError: () => closeDialog(),
    onSuccess: () => {
      showSuccess()
    },
  })
}

export default useUpdate
